export default "__VITE_ASSET__uR82gDQu__"